export enum TranscriptStatus {
  InProgress = 'in-progress',
  Completed = 'completed',
}

export interface ITranscriptChunk {
  transcriptChunkId: string;

  /* callActionId */
  transcriptId: string;
  audioChunkFileKey: string;

  text: string;
  normalisedText?: string;
  speaker: string;

  /* seconds */
  timestampStart: number;
  timestampStartTimestamp: string;

  /* seconds */
  timestampEnd: number;
  timestampEndTimestamp: string;

  status: TranscriptStatus;

  savedQuote: boolean;
}

export interface IExtendedTranscriptChunk extends ITranscriptChunk {
  loading?: boolean;
  downloading?: boolean;
  highlighted?: boolean;
}
